import { goToSearchUrl } from '../../helpers/search';

export default function () {
    return {
        topSearchDisplayClass: 'active-top-search',
        showTopSearchInputOffset: 660,
        submitDisabled: true,

        init() {
            this.setupListeners();
        },

        submitSearch() {
            const query = this.$refs.input.value;
            goToSearchUrl(query);
        },

        handleScroll() {
            const { body } = document;
            const show = window.pageYOffset > this.showTopSearchInputOffset;

            show
                ? body.classList.add(this.topSearchDisplayClass)
                : body.classList.remove(this.topSearchDisplayClass);
        },

        setupListeners() {
            window.addEventListener('search-key-up', () => {
                this.submitDisabled = false;
            });
        }
    };
}
